import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CommonBaseURl } from "../../../Commonprovider/CommonProvider";


export const UserLogin = createAsyncThunk("loginapi", async (Data) => {
    var requestOptions = {
        method: 'POST',
        body: JSON.stringify({
            "username": Data.username,
            "password": Data.Password
        }),
        headers: {
            'Content-type': 'application/json; charset=UTF-8',
        },
    };
    let response = await fetch(`${CommonBaseURl}LoginFlag`, requestOptions)
    return response.json()
})


export const loginapi = createSlice({
    name: "userLogin",
    initialState: {
        data: null,
        Userlogin: null,
        loading: false,
        error: false
    },
    extraReducers: (builder) => {
        builder.addCase(UserLogin.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.error = false
            state.Userlogin = true
        })
        builder.addCase(UserLogin.rejected, (state, action) => {
            state.loading = false
            state.error = true
            state.Userlogin = false
        })
        builder.addCase(UserLogin.pending, (state, action) => {
            state.loading = true
            state.error = false
            state.Userlogin = false
        })
    },
    reducers: ({
        logoutredux: (state, action) => {
            state.data = null
            state.loading = false
            state.error = false
        },
        setIPLogindetails: (state, action) => {
            state.data = action.payload
            state.loading = false
            state.error = false
            state.Userlogin = true
        }
    }),
   
})


export const {
    logoutredux,
    setIPLogindetails
} = loginapi.actions
export default loginapi.reducer


